export const tickerSkills = [
  { name: "React/Next.js", rating: 6.1, change: "+6.1", trend: "up" },
  { name: "Financial Analysis", rating: 9.5, change: "+0.5", trend: "up" },
  { name: "Excel", rating: 9.6, change: "+0.3", trend: "up" },
  { name: "SAP Systems", rating: 7.4, change: "+3.2", trend: "up" },
  { name: "Python", rating: 7.1, change: "-0.1", trend: "down" },
  { name: "Power BI", rating: 8.5, change: "+0.2", trend: "up" },
];

export const duplicatedSkills = [...tickerSkills, ...tickerSkills, ...tickerSkills];

export const interests = [
  "Fintech Innovation",
  "Investment Management",
  "Commercial Finance",
  "Artificial Intelligence",
  "Supply Chain Management",
  "Blockchain Technology",
];

export const categories = [
  "Home",
  "Companies",
  "Markets",
  "Fintech",
  "Policy",
  "Tech Trends",
  "Investments",
  "Career Insights",
  "Projects",
  "Research",
  "Opinion",
];

export const careerTimeline = [
  { title: "Student", company: "University of NSW", years: "2020-2024", active: false },
  { title: "Investment Intern", company: "Advance VC", years: "2024", active: false },
  { title: "Investor Services Associate", company: "Automic Group", years: "2024", active: false },
  { title: "Investment Associate", company: "NextGen Ventures", years: "2024", active: false },
  { title: "Financial Analyst", company: "Unilever", years: "2025-Present", active: true },
];
